// extracted by mini-css-extract-plugin
module.exports = {"bg":"Licence_bg__1Z2Lr"};